module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui medium statistic"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.data.fullName))]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm._f("kmb")(_vm.data.lastMonthValue)))])]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "subdued"
  }, [_vm._v(_vm._s(_vm.data.lastMonth))]), _vm._v(" "), _c('span', {
    staticClass: "change label"
  }, [_c('arrow-icon', {
    attrs: {
      "value": _vm.data.changeMoM
    }
  }), _vm._v("\n            " + _vm._s(_vm.data.changeMoM) + " % month over month\n        ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "line-chart"
  }), _vm._v(" "), _c('div', {
    staticClass: "ui horizontal small statistic"
  }, [_c('div', {
    staticClass: "value"
  }, [_vm._v("\n            " + _vm._s(_vm._f("kmb")(_vm.data.lastYearValue)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "change label"
  }, [_c('arrow-icon', {
    attrs: {
      "value": _vm.data.changeYoY
    }
  }), _vm._v("\n            " + _vm._s(_vm.data.changeYoY) + " % year over year\n        ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "year total subdued"
  }, [_vm._v("\n        Year Total (" + _vm._s(_vm.data.lastYear) + ")\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-43d138e6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MetricLineWidget.vue
// module id = 388
// module chunks = 1